const lowestAge = 17;
const highestAge = 90;

export default class Calendar {
    constructor() {
        this.yRange = this._yearsRange();
        this.year = this.yRange[0];
        this.month = 0;
        this.day = 1;

        this.days = 31;
    }

    setYear(value) {
        if (this.withinYRange(value)) {
            this.year = value;
            this.updateDays();
        }
    }

    withinYRange(year) {
        return this.yRange[0] >= year && this.yRange[this.yRange.length - 1] <= year;
    }

    setMonth(value) {
        this.month = value;
        this.updateDays();
    }

    setDay(value) {
        this.day = value;
    }

    updateDays() {
        const d = Calendar.daysInMonth(this.year, this.month);
        this.days = d;
        if (this.day > d) {
            this.day = null;
        }
    }

    _yearsRange() {
        const y = new Array(highestAge);
        const m = this.maxYear();
        for (let i = 0; i < y.length; i++) {
            y[i] = m - i;
        }
        return y;
    }

    maxYear() {
        return new Date().getFullYear() - lowestAge;
    }

    static daysInMonth(y, m) {
        return 32 - new Date(y, m, 32).getDate();
    }

    toString() {
        const month = "0" + (this.month + 1);
        const day = "0" + this.day;
        return `${ day.substr(-2) }/${ month.substr(-2) }/${ this.year }`;
    }

    get date() {
        if (this.year != null && this.month != null && this.day != null) {
            return new Date(this.year, this.month, this.day);
        }
        return null;
    }

    set date(val) {
        if (!val) return;
        this.setYear(val.getFullYear());
        this.setMonth(val.getMonth());
        this.setDay(val.getDate());
    }
}